module.exports = __webpack_public_path__ + "img/xl_fj.3a6ac294.png";